import axiosInstance from "../../../../lib/axiosInstance";

// Account-synced setup comparisons — mirrors the Log Analyzer's
// /telemetry/comparisons CRUD. Authed (bearer), user-scoped server-side.
// See vecros-api/docs/FRONTEND-REQUESTS.md ("Propulsion setup comparisons").

const detailMessage = (error, fallback) => {
  const d = error?.response?.data?.detail;
  if (!d) return fallback;
  return typeof d === "string" ? d : JSON.stringify(d);
};

export const listSetupComparisons = async () => {
  try {
    const { data } = await axiosInstance.get("/propulsion/comparisons");
    return data.comparisons || [];
  } catch (error) {
    throw new Error(detailMessage(error, "Failed to load comparisons"));
  }
};

export const getSetupComparison = async (id) => {
  try {
    const { data } = await axiosInstance.get(`/propulsion/comparisons/${id}`);
    return data.comparison;
  } catch (error) {
    throw new Error(detailMessage(error, "Failed to load comparison"));
  }
};

export const createSetupComparison = async ({ name, entries }) => {
  try {
    const { data } = await axiosInstance.post("/propulsion/comparisons", { name, entries });
    return data.comparison; // { id, name, entries, created_at }
  } catch (error) {
    throw new Error(detailMessage(error, "Failed to save comparison"));
  }
};

export const deleteSetupComparison = async (id) => {
  try {
    await axiosInstance.delete(`/propulsion/comparisons/${id}`);
  } catch (error) {
    throw new Error(detailMessage(error, "Failed to delete comparison"));
  }
};
